'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { useState } from 'react';
import { CommandStoreContext, createCommandStore } from './registry';

/**
 * Command Provider component
 * Holds the command store. The store never changes identity, so components that register commands
 * don't re-render when commands change.
 */
export function CommandProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const [store] = useState(createCommandStore);
  let t1;
  if ($[0] !== children || $[1] !== store) {
    t1 = <CommandStoreContext value={store}>{children}</CommandStoreContext>;
    $[0] = children;
    $[1] = store;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}